/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PasswordChangePart.vue?vue&type=template&id=0449092f"
import script from "./PasswordChangePart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordChangePart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordChangePart.vue?vue&type=style&index=0&id=0449092f&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports